import React from 'react';
import { useGameStore } from '../../store/gameStore';
import { useTranslation } from '../../hooks/useTranslation';
import { BuildingModal } from './BuildingModal';

interface TempleModalProps {
  onClose: () => void;
}

export const TempleModal: React.FC<TempleModalProps> = ({ onClose }) => {
  const t = useTranslation();
  const { buildings, fighters, resources, updateFighter, buildBuilding } = useGameStore();

  const handleHeal = () => {
    if (!buildings.temple) return;
    
    fighters.forEach(fighter => {
      updateFighter(fighter.id, { health: fighter.maxHealth });
    });
  };

  const handleBuild = () => {
    if (!buildings.temple) {
      buildBuilding('temple');
    }
  };

  return (
    <BuildingModal
      title={t.modals.temple.title}
      onClose={onClose}
      content={
        <div className="text-white font-pixel text-xs space-y-4">
          {!buildings.temple ? (
            <div className="flex flex-col items-center justify-center py-12">
              <img
                src="./sprites/buildings/temple.png"
                alt={t.base.temple}
                className="w-24 h-24 mb-6 object-contain filter drop-shadow-[0_0_8px_rgba(255,255,255,0.8)]"
                onError={(e) => {
                  (e.target as any).style.display = 'none';
                  const el = (e.target as any).parentElement;
                  if (!el.getAttribute('data-has-emoji')) {
                    el.setAttribute('data-has-emoji', 'true');
                    el.insertAdjacentHTML('afterbegin', '<div class="text-6xl mb-6">⛪</div>');
                  }
                }}
              />
              <div className="mb-6 text-gray-400 uppercase tracking-widest text-sm">{t.modals.temple.notBuilt}</div>
              <button
                onClick={handleBuild}
                disabled={resources.wood < 100}
                style={{
                  backgroundColor: resources.wood >= 100 ? '#ca8a04' : '#374151',
                  color: resources.wood >= 100 ? '#000' : '#9ca3af',
                  padding: '0.75rem 1.5rem',
                  fontSize: '0.7rem',
                  fontWeight: 'bold',
                  fontFamily: '"Press Start 2P", cursive, sans-serif',
                  border: 'none',
                  borderRadius: '0.25rem',
                  cursor: resources.wood >= 100 ? 'pointer' : 'not-allowed',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  boxShadow: resources.wood >= 100 ? '0 4px 0 #854d0e' : 'none',
                  transition: 'none'
                }}
                onMouseDown={(e) => {
                  if (resources.wood >= 100) {
                    e.currentTarget.style.transform = 'translateY(2px)';
                    e.currentTarget.style.boxShadow = '0 2px 0 #854d0e';
                  }
                }}
                onMouseUp={(e) => {
                  if (resources.wood >= 100) {
                    e.currentTarget.style.transform = 'translateY(0)';
                    e.currentTarget.style.boxShadow = '0 4px 0 #854d0e';
                  }
                }}
              >
                {t.modals.temple.build} {t.modals.temple.buildCost}
              </button>
            </div>
          ) : (
            <div className="flex flex-col items-center justify-center py-12">
              <div className="mb-6 text-center">{t.modals.temple.healDescription}</div>
              <button
                onClick={handleHeal}
                style={{
                  backgroundColor: '#ca8a04',
                  color: '#000',
                  padding: '0.75rem 1.5rem',
                  fontSize: '0.7rem',
                  fontWeight: 'bold',
                  fontFamily: '"Press Start 2P", cursive, sans-serif',
                  border: 'none',
                  borderRadius: '0.25rem',
                  cursor: 'pointer',
                  textTransform: 'uppercase',
                  letterSpacing: '0.1em',
                  boxShadow: '0 4px 0 #854d0e',
                  transition: 'none'
                }}
                onMouseDown={(e) => {
                  e.currentTarget.style.transform = 'translateY(2px)';
                  e.currentTarget.style.boxShadow = '0 2px 0 #854d0e';
                }}
                onMouseUp={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 0 #854d0e';
                }}
              >
                {t.modals.temple.healAll}
              </button>
            </div>
          )}
        </div>
      }
    />
  );
};



